import { DataGrid } from '@mui/x-data-grid'

export default function DataGridTable({
	rows,
	columns,
	checkboxSelection = true,
	pageSizeOptions = [5, 10, 25],
	initialPageSize = 10,
	height = '70dvh',
	sx,
	...rest
}) {
	return (
		<div style={{ height, width: '100%' }}>
			<DataGrid
				rows={rows}
				columns={columns}
				checkboxSelection={checkboxSelection}
				disableRowSelectionOnClick
				pageSizeOptions={pageSizeOptions}
				initialState={{
					pagination: {
						paginationModel: { pageSize: initialPageSize, page: 0 },
					},
				}}
				// hideFooter // temporary hide the footer
				sx={{
					border: 0,
					'& .MuiDataGrid-row': { 
                        borderRadius: 1,
                        cursor: rest.onRowClick ? 'pointer' : 'default'
                    },
					'& .MuiDataGrid-menuIcon': {
						display: 'none',
					},
					'& .MuiDataGrid-iconSeparator': {
						display: 'none',
					},
					'& .MuiDataGrid-filler .css-1tdeh38': {
						display: 'none',
					},
					'& .MuiDataGrid-row--borderBottom': {
						height: '48px !important',
					},

					'& .MuiCheckbox-root': {
						color: '#DFE4EB',
						'&.Mui-checked': {
							color: '#7ca6bd',
						},
					},
					...sx,
				}}
				{...rest}
				className="table-wrp"
			/>
		</div>
	)
}
